import React from "react";
import "./image-view.css";

export function ImageView(props) {
  function closeModal(e) {
    let modal = document.getElementById("modal");
    if (e.target === modal) {
      props.close();
    }
  }

  function downloadImage() {
    const link = document.createElement("a");
    link.download = `${props.logCode}-receipt`;
    link.href = props.image;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <div id="modal" className="image-modal" onClick={closeModal}>
      <span className="close" onClick={() => props.close()}>
        &times;
      </span>
      <div className="modal-content">
        <p className="p-text-left">Receipt</p>

        <img src={props.image} alt="receipt" className="image" />
        <div className="flex default end p-mt-5">
          <button
            onClick={downloadImage}
            className="primary-button"
            style={{ width: "200px" }}
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
}
